skrilla.controller('sportsExclusionsModalCtrl', async function ($scope, searchService, cacheService, modalService,
                                                                sportService, validationService,
                                                                userExclusionsService, dateService) {
    let validation = validationService;
    $scope.validate = {}
    $scope.sports = await sportService.getSports()
    $scope.pageKey = "sportsExclusions";
    let data = cacheService.getObject($scope.pageKey);
    $scope.update = {indefinite: validationService.isEmpty(data.exclusion.effectiveUntil)};
    $scope.person = data.person
    $scope.newSportsExclusion = data.exclusion
    $scope.minDate = dateService.getTomorrowDate()
    userExclusionsService.getRequesterTypes('sports').then(function(requesters){$scope.requesters = requesters});

    $scope.save = function () {
        if (validate()) {
            modalService.confirm("Are you sure you'd like to update the register?", function () {
                if ($scope.update.indefinite) {
                    $scope.newSportsExclusion.effectiveUntil = null
                }
                $scope.newSportsExclusion.id ? update() : create()
            });
        }
    }

    function create() {
        searchService.post(`sportsExclusions/person/${$scope.person.id}`, $scope.newSportsExclusion,
            "Exclusion successfully added!").then(modalService.dismissAll)
    }

    function update() {
        searchService.put("sportsExclusions/" + $scope.newSportsExclusion.id, $scope.newSportsExclusion,
            "Register Successfully updated!").then(modalService.dismissAll)
    }

    $scope.delete = function () {
        modalService.confirm("Are you sure you'd like remove this exclusion?", function () {
            searchService.deleteRequest("sportsExclusions/" + $scope.newSportsExclusion.id,
                "Exclusion successfully removed!").then(modalService.dismissAll)
        });
    }

    function validate(){
        let inputs = [
            validation.buildFieldValidationObj("sport", validation.isNotEmpty($scope.newSportsExclusion.sport), "Please select a sport"),
            validation.buildFieldValidationObj("requester", validation.isNotEmpty($scope.newSportsExclusion.requester), "Please select a requester"),
            validation.buildFieldValidationObj("reason", validation.isNotEmpty($scope.newSportsExclusion.reason), "Please enter a reason"),
            validation.buildFieldValidationObj("effectiveUntil", $scope.update.indefinite || validation.isNotEmpty($scope.newSportsExclusion.effectiveUntil), "Please select a time period"),
        ];
        return validation.validateForm(inputs, $scope.validate)
    }

});
